"use client";

import { useScrollToTop } from "@/hooks/useScrollToTop";
import Link from "next/link";
import { useEffect, useState } from "react";
import { FaAngleUp } from "react-icons/fa";
import { ImWhatsapp } from "react-icons/im";

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
export const ScrollToTop = () => {
  useScrollToTop()

  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      const scrolledFromTop = window.scrollY;
      const windowHeight = window.innerHeight;

      if (scrolledFromTop > windowHeight - 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);
  return (
    <div className="fixed flex gap-4 z-50 bottom-6 right-4">
      <Link
        target="_blank"
        href="https://wa.me/+963987233122"
        className="  text-white transition-all ltr:order-1 rtl:order-0 duration-200 "
      >
        <ImWhatsapp aria-label="whatsApp" className=" animate-bounce text-5xl cursor-pointer bg-whatsappGreen hover:bg-[#19bb55] px-2 rounded-md" />
      </Link>
      <button
        onClick={scrollToTop}
        className={`cursor-pointer ${
          isVisible ? "block" : "hidden"
        } rounded-full bg-linear-to-r from-primary from-20% to-secondary px-4 py-3 text-white`}
      >
        <FaAngleUp aria-label="scroll-to-top" className="h-5 w-3" />
      </button>
    </div>
  );
};
